"use client";

import { c as _c } from "react/compiler-runtime";
import NotificationsPage from "@/components/notifications/NotificationsPage";
export default function NotificationsPageClient() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NotificationsPage />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}